const PWA_DISPLAY_MODES: string[] = [
  'standalone',
  'fullscreen',
  'minimal-ui',
  'window-controls-overlay',
] as const;
const PWA_RELATED_WEB_APP_PLATFORM = 'webapp';

export { PWA_DISPLAY_MODES, PWA_RELATED_WEB_APP_PLATFORM };
